import { render, staticRenderFns } from "./CourseDetails.vue?vue&type=template&id=0662026c&scoped=true"
import script from "./CourseDetails.vue?vue&type=script&lang=js"
export * from "./CourseDetails.vue?vue&type=script&lang=js"
import style0 from "./CourseDetails.vue?vue&type=style&index=0&id=0662026c&prod&scoped=true&lang=css"
import style1 from "./CourseDetails.vue?vue&type=style&index=1&id=0662026c&prod&scoped=true&lang=css"
import style2 from "./CourseDetails.vue?vue&type=style&index=2&id=0662026c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0662026c",
  null
  
)

export default component.exports